import React from 'react';

import { observer } from 'mobx-react';

import classes from './TimerBlock.module.scss';
import { CountdownTimer } from '../../../../../shared/components/ui-components';
import { checkoutStore } from '../../../../stores/checkoutStore';
import { getRouteParam, goTo } from '../../../../../shared/utils/angularUtils';
import { pathQueryParams } from '../../../../constants/pathQueryParams';

const TimerBlock = observer(() => {
  const retryPath = getRouteParam(pathQueryParams.retryPath);

  const { checkoutInfo } = checkoutStore;

  if (!checkoutInfo) {
    return null;
  }

  const handleTimeOver = () => {
    goTo('/payment-result', {
      params: {
        [pathQueryParams.redirectStatus]: 'failed',
        retryPath,
      },
    });
  };

  return (
    <div className={classes.container}>
      <p className={classes.title}>Complete payment before the specified time expires</p>
      <CountdownTimer
        expirationEpoch={checkoutInfo.checkoutDetails.expirationEpoch}
        units={['minutes', 'seconds']}
        onTimeOver={handleTimeOver}
      />
    </div>
  );
});

export { TimerBlock };
